export const CURRENT_USER_REQUEST   = 'CURRENT_USER_REQUEST';
export const CURRENT_USER_RECEIVE   = 'CURRENT_USER_RECEIVE'; 
export const CURRENT_USER_FAILURE   = 'CURRENT_USER_FAILURE';

export const FETCH_USER_REQUEST     = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS     = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE     = 'FETCH_USER_FAILURE';
